<template>
  <v-dialog v-model="show" persistent max-width="350">
    <v-card>
      <v-card-title class="text-h3 px-10 py-6 dialog-title">
        {{ $t('PRICE_MODAL_TITLE') }}
      </v-card-title>

      <v-divider />

      <v-container>
        <v-text-field
          dense
          :label="label"
          prepend-icon="mdi-pencil"
          type="number"
          class="d-flex align-center"
          v-model="newPrice"
        />
      </v-container>

      <v-divider />

      <v-card-actions class="d-flex justify-end pa-4">
        <v-btn
          class="non-text-transformation link"
          tile
          large
          outlined
          color="primary"
          @click.stop="close"
        >
          {{ $t('PRICE_MODAL_CANCEL') }}
        </v-btn>

        <v-btn
          tile
          large
          class="ml-4 non-text-transformation link"
          color="primary"
          @click="changePrice"
        >
          {{ $t('PRICE_MODAL_CHANGE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    initialPrice: {
      type: Number,
    },
  },
  data() {
    return {
      newPrice: null,
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    label() {
      return this.initialPrice !== undefined ? this.initialPrice.toString() : ''
    },
  },
  methods: {
    changePrice() {
      if (this.newPrice) {
        this.$emit('changePrice', Number(this.newPrice))
      }
      this.close()
    },
    close() {
      this.show = false
      this.newPrice = null
    },
  },
}
</script>
